"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFS = void 0;
const tab_1 = require("../../../tab");
exports.IFS = {
    description: 'returns the value of the first truthy condition',
    arg_names: ['pairs'],
    args_def: [
        {
            types: ['string', 'number', 'boolean', 'date'],
            required: true,
            variadic: true,
        },
    ],
    args_description: ['Pairs of condition, value'],
    multipleReturnType: true,
    return_type: tab_1.ColumnType.STRING || tab_1.ColumnType.NUMBER || tab_1.ColumnType.BOOLEAN || tab_1.ColumnType.DATE,
};
